import { StatusColumn } from "./AttendanceTable";
import { REGULARIZATION_STAGES } from '../../config/regularizationStages';

export const TABLE_INTERVAL_WEEKLY = 'weekly'
export const TABLE_INTERVAL_MONTHLY = 'monthly'

export const ALL_COLUMNS = {
    DATE: 'Date',
    CLOCK_IN: 'Clock In',
    CLOCK_OUT: 'Clock Out',
    WORKING_HOURS: 'Working Hours',
    STATUS: ''
}

export const COLUMN_FIELDS = {
    DATE: 'createdAt',
    CLOCK_IN: 'clockIn',
    CLOCK_OUT: 'clockOut',
    WORKING_HOURS: 'workingHours',
    REGULARIZATION_STATUS: 'regularization'
}

export const statusObj = {
    [REGULARIZATION_STAGES.PENDING]: {
        color: "#FFBE24",
        stage: "Pending"
    },

    [REGULARIZATION_STAGES.PRESENT]: {

        color: '#96CE85',
        stage: "Approved (P)",
    },
    [REGULARIZATION_STAGES.HALF_DAY]: {

        color: '#96CE85',
        stage: "Approved (HD)",
    },
    [REGULARIZATION_STAGES.ABSENT]: {

        color: '#E58526',
        stage: "Rejected",
    },



}



export const DisplayStatus = (regularizationObj, docId) => {

    const { status, isRegularizationAllowed = true } = regularizationObj



    if (status === REGULARIZATION_STAGES.APPLICABLE) {
        return <StatusColumn docId={docId} isRegularizationAllowed={isRegularizationAllowed} />
    }
    else {
        if (status === REGULARIZATION_STAGES.NOT_APPLICABLE) {
            return null
        }
        else {

            return (< div className=" text-xs flex justify-content-start align-items-center font-semibold" style={{ color: statusObj[status]?.color }}>
                <i className="pi pi-circle-fill mr-2" style={{ fontSize: '0.5rem' }}></i>
                {statusObj[status]?.stage}
            </div>)
        }

    }

}



